import React from 'react';
import ConversationListItem from './ConversationListItem';

function ConversationList({ conversations, currentUserId, loading, onConversationClick }) {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (!conversations?.length) {
    return (
      <div className="text-center py-12 px-4 text-gray-500">
        <p>No conversations yet.</p>
        <p className="text-sm mt-1">Contact a seller from an ad to start a conversation.</p>
      </div>
    );
  }

  return (
    <ul className="divide-y divide-gray-200">
      {conversations.map((conv) => (
        <li key={conv.id}>
          <ConversationListItem
            conversation={conv}
            currentUserId={currentUserId}
            onClick={onConversationClick}
          />
        </li>
      ))}
    </ul>
  );
}

export default ConversationList;
